import * as constants from "./constants";

export const fetchLabStatuses = (data) => {
  return {
    type: constants.FETCH_LAB_STATUSES,
    data,
  };
};

export const fetchLabStatusesSuccess = (data) => {
  return {
    type: constants.FETCH_LAB_STATUSES_SUCCESS,
    data: data,
  };
};

export const fetchLabStatusesError = (data) => {
  return {
    type: constants.FETCH_LAB_STATUSES_ERROR,
    data: data,
  };
};

export const updateLabStatuses = (data) => {
  return {
    type: constants.UPDATE_LAB_STATUSES,
    data: data,
  };
};

export const updateLabStatusesSuccess = (data) => {
  return {
    type: constants.UPDATE_LAB_STATUSES_SUCCESS,
    data: data,
  };
};

export const updateLabStatusesError = () => {
  return {
    type: constants.UPDATE_LAB_STATUSES_ERROR,
  };
};

export const updateLabsOrder = (data) => {
  return {
    type: constants.UPDATE_ORDER,
    data: data,
  };
};

export const updateLabsOrderSuccess = (data) => {
  return {
    type: constants.UPDATE_ORDER_SUCCESS,
    data: data,
  };
};

export const updateLabsOrderError = () => {
  return {
    type: constants.UPDATE_ORDER_ERROR,
  };
};

export const deleteLabStatuses = (data) => {
  return {
    type: constants.DELETE_LAB_STATUSES,
    data: data,
  };
};

export const deleteLabStatusesSuccess = (data) => {
  return {
    type: constants.DELETE_LAB_STATUSES_SUCCESS,
    data: data,
  };
};

export const deleteLabStatusesError = () => {
  return {
    type: constants.DELETE_LAB_STATUSES_ERROR,
  };
};

export const createLabStatuses = (data, id) => {
  return {
    type: constants.CREATE_LAB_STATUSES,
    data: data,
  };
};

export const createLabStatusesSuccess = (data) => {
  return {
    type: constants.CREATE_LAB_STATUSES_SUCCESS,
    data: data,
  };
};

export const createLabStatusesError = (id) => {
  return {
    type: constants.CREATE_LAB_STATUSES_ERROR,
    id,
  };
};

export const isAddingAction = (data) => {
  return {
    type: constants.IS_ADDING_UPDATE,
    data,
  };
};
